import { rootApi } from 'root-api'

const api = rootApi.enhanceEndpoints({ addTagTypes: ['Meeting', 'Invitee'] }).injectEndpoints({
  endpoints: (build) => ({
    fetchPromptSuggestions: build.query({
      query: ({ meetingUuid }) => ({
        url: '/api/meetings_qna/suggested_questions',
        method: 'POST',
        data: { meetingUuid }
      })
    }),
    submitSearchRequest: build.query({
      query: ({ meetingUuid, query }) => ({
        url: '/api/meetings_qna/answer',
        method: 'POST',
        data: { meetingUuid, query }
      })
    })
  })
})

export const { useFetchPromptSuggestionsQuery, useSubmitSearchRequestQuery } = api
